import { httpApi } from '@api/http.api.ts';
import type {
    ANSWER_STATUS,
    COMMON_QUIZ_STATUS,
    QUIZ_NOTIFICATION,
} from '@routes/sidebar/learning/___pages___/learning-overview/ui/overview/quiz/___shared___/constants.ts';

type CommonQuizStatus = (typeof COMMON_QUIZ_STATUS)[keyof typeof COMMON_QUIZ_STATUS];

// keep in this way, just in case if we need to add more statuses in the future
export type FinalQuizStatus = CommonQuizStatus;
export type AnswerStatus = (typeof ANSWER_STATUS)[keyof typeof ANSWER_STATUS];
export type QuizNotification = (typeof QUIZ_NOTIFICATION)[keyof typeof QUIZ_NOTIFICATION];

export interface FinalQuizInfoResponse {
    maxAttempts: number;
    attempt: number;
    numberOfQuestions: number;
    durationInSeconds: number;
    remainingTimeSeconds: number;
    requiredPercentScore: number;
    highestPercentScore: number;
    currentPercentScore: number;
    approach: number;
    quizStatus: FinalQuizStatus;
    quizNotification: QuizNotification;
    startedAtUTC: string;
    finishedAtUTC: string;
    quizEndsAtUTC: string;
    pathwayItemsToReview: number[];
}

export interface FinalQuizUserQuestionsResponse {
    finalQuizQuestion: QuizQuestion[];
    finalQuizDescription: FinalQuizInfoResponse;
}

export interface QuizAnswer {
    id: number;
    text: string;
    questionId: number;
}

export interface FinalQuizAnswerRequest {
    answersIds: number[];
    questionId: number;
}

export interface QuizAnswerResponse {
    correct: number[];
    quizQuestionAnswerStatus: AnswerStatus;
}

export interface QuizQuestion {
    id: number;
    questionText: string;
    answers: QuizAnswer[];
    userAnswers: number[];
    correctAnswers: number[];
    selectAllRight: boolean;
    quizQuestionAnswerStatus: AnswerStatus;
    introText: string | null;
    outroText: string | null;
}

export const getApiFinalQuizData = (pathwayId: string, quizId: number): Promise<FinalQuizInfoResponse> =>
    httpApi.get<FinalQuizInfoResponse>(`learning/${pathwayId}/final-quiz/${quizId}`).then(({ data }) => data);

export const postApiFinalQuizStart = (pathwayId: string, quizId: number): Promise<FinalQuizUserQuestionsResponse> =>
    httpApi
        .post<FinalQuizUserQuestionsResponse>(`learning/${pathwayId}/final-quiz-start/${quizId}`, {})
        .then(({ data }) => data);

export const postApiFinalQuizAnswer = (
    payload: FinalQuizAnswerRequest,
    quizId: number,
    pathwayId: string,
): Promise<QuizAnswerResponse> =>
    httpApi
        .post<QuizAnswerResponse>(`learning/${pathwayId}/final-quiz-answer/${quizId}`, {
            ...payload,
        })
        .then(({ data }) => data);

export const postApiFinalQuizFinish = (pathwayId: string, quizId: number): Promise<FinalQuizInfoResponse> =>
    httpApi
        .post<FinalQuizInfoResponse>(`learning/${pathwayId}/final-quiz-finish/${quizId}`, {})
        .then(({ data }) => data);

export const postResetFinalQuizData = (pathwayId: string, quizId: number): Promise<any> =>
    httpApi.post<any>(`learning/${pathwayId}/final-quiz-reset/${quizId}`).then(({ data }) => data);
